import { getActiveBrokerId, getAvailableBrokers, switchBroker } from '../services/broker/broker-registry.js';

const LABELS = {
  tradier: 'Tradier',
  ibkr: 'Interactive Brokers'
};

export function createBrokerSelector({ onChange } = {}) {
  const el = document.createElement('div');
  el.className = 'broker-selector';

  const available = getAvailableBrokers();
  const options = available.map((id) => `<option value="${id}">${LABELS[id] || id}</option>`).join('');

  el.innerHTML = `
    <label class="api-label" for="broker-selector-input">Broker</label>
    <select id="broker-selector-input" class="broker-select">${options}</select>
  `;

  const selectEl = el.querySelector('#broker-selector-input');
  selectEl.value = getActiveBrokerId();
  selectEl.addEventListener('change', () => {
    const brokerId = selectEl.value;
    switchBroker(brokerId);
    if (typeof onChange === 'function') onChange(brokerId);
  });

  return {
    el,
    destroy() {}
  };
}
